import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// Available languages
export const supportedLanguages = ['en', 'id']

// Initialize i18next with HTTP backend (load translations on demand)
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Language detection options
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupQuerystring: 'lan',
      lookupLocalStorage: 'lang_code',
    },

    // Supported languages
    supportedLngs: supportedLanguages,

    // Fallback language (default to Indonesian)
    fallbackLng: 'id',

    // Namespace
    defaultNS: 'common',
    ns: ['common'],

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // React integration
    react: {
      useSuspense: false,
    },

    // HTTP backend configuration - loads translations on demand
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Preload default language
    preload: ['id'],

    // Load only current language initially
    load: 'currentOnly',
  })

export default i18n
